import React, {useEffect, useState} from 'react';
import {useAuthentication} from "./AuthProvider";
import {UserCapability} from "../models/capabilities";
import {UserInfo} from "../models/user-info.model";
import {run} from "../utils/function-util";

interface ICapabilityContext {
    user: UserInfo | null,
    capabilities: {[organizationId: number]: UserCapability},
    setCapabilities: (newCapabilities: {[organizationId: number]: UserCapability}) => void,
    hasRole: (role: string) => boolean,
    userRoles?: string[]
}
const CapabilityContext = React.createContext<ICapabilityContext>(({} as any));

function useCapability() {
    const context = React.useContext(CapabilityContext);
    if (!context)
        throw new Error('useCapability must be used within a CapabilityContext Provider')
    return context;
}

const CapabilityProvider = (props: any) => {
    const { getUser, getRoles } = useAuthentication();
    const [userRoles, setUserRoles] = useState<string[]>();
    const [user, setUser] = useState<UserInfo | null>(null);
    const [capabilities, setCapabilitiesImpl] = useState({});

    useEffect(() => {
        (async () => setUserRoles(await getRoles()))();
    }, [getRoles]);

    useEffect(run(getUser, setUser), [getUser]);

    const setCapabilities = (overwrite: any) => {
        setCapabilitiesImpl({...capabilities, ...overwrite});
    }

    const hasRole = (role: string) => {
        return Array.isArray(userRoles)
            && !!role
            && userRoles.some(r => r.toLowerCase() === role.toLowerCase());
    };

    return (
        <CapabilityContext.Provider value={{user, capabilities, setCapabilities, hasRole, userRoles}}>
            {props.children}
        </CapabilityContext.Provider>
    )
}

export { CapabilityProvider, useCapability };
